import {
  Avatar, AvatarProps, ICON_LIST_BOX_OUTLINE,
} from '@doveit/bricks';
import React from 'react';

export type TaskAvatarProps = Pick<AvatarProps, 'size' | 'placeholder'>;

export const TaskAvatar: React.FC<TaskAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_LIST_BOX_OUTLINE}
  />
);

export default TaskAvatar;
